import React from "react"

import FTPServer from "../../../../components/Internet_Access/Videos/video-point-to-point"

import SEOHelmet from '../../../../components/Layout/SEOHelmet'
import Footer from "../../../../components/Layout/footer"

const seodata = {
  title: 'P2P Remote Access',
  description: 'Use the INSTAR P2P Service to connect your phone to your camera the easy way. Just search for the QR Code under Network/P2P and scan it with our smartphone.',
  image: '/images/Search/IA_SearchThumb_P2P.png'
}

export default (props) => (
  <React.Fragment>
    <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={props.location.pathname} />
    <h1 id="introduction" style={{ marginTop: 0 }}>
      Das Prinzip von DDNS, Portweiterleitung und P2P in einfachen Worten erklärt
    </h1>
    <FTPServer />
    <br />
    <br />
    <Footer
      previousTitle="Internet Access"
      previousLink="/fr/Internet_Access/"
      nextTitle="Point-to-Point"
      nextLink="/fr/Internet_Access/Point_to_Point/" />
  </React.Fragment>
)